/*
 * @Author: xiaoyuling
 * @Date: 2024-09-24 18:13:19
 * @LastEditTime: 2024-12-16 14:21:55
 * @LastEditors: xiaoyuling
 * @Description: edit
 * @FilePath: /IOT4CMS/src/components/Preview/index.tsx
 */
import React, { FC, useState } from 'react'

import headPhotoIcon from '@/assets/images/head.png'
import closeIcona from '@/assets/images/preview/close_a.png'
import leftIcon from '@/assets/images/preview/l_a.png'
import rightIcon from '@/assets/images/preview/r_a.png'

import ss from './index.less'
import { message } from 'antd'

interface PreviewProps {
	data: any
	onClick: () => void
}

const PreviewBOX: FC<PreviewProps> = ({ data, onClick }) => {
	const [current, setCurrent] = useState(0)
	//下
	const onNext = e => {
		e.stopPropagation()
		if (current < data.length - 1) {
			setCurrent(current + 1)
		} else {
			return
		}
	}
	// 上
	const onLast = e => {
		e.stopPropagation()
		if (current > 0) {
			setCurrent(current - 1)
		} else {
			return
		}
	}
	return (
		<div className={ss.previewBox} onClick={onClick}>
			<div className={ss.top}>
				<span className={ss.count}>
					<i>{current + 1}</i> / {data?.length || 0}
				</span>
				<img className={ss.closeIcon} src={closeIcona} alt="" />
			</div>
			<div className={ss.contentBox}>
				<span className={ss.todoIcon}>
					<img src={leftIcon} alt="" onClick={e => onLast(e)} />
				</span>
				<div className={ss.viewBox}>
					<img src={data[current]} alt="" />
				</div>
				<span className={ss.todoIcon}>
					<img src={rightIcon} alt="" onClick={e => onNext(e)} />
				</span>
			</div>
		</div>
	)
}

export default PreviewBOX
